import React, { useState, useEffect } from 'react';
import './Carousel.css';

// Import your images
import img1 from '../assets/Page1/img1.png';
import img2 from '../assets/Page1/img2.png';
import img3 from '../assets/Page1/img3.png';
import img4 from '../assets/Page1/img4.png';
import img5 from '../assets/Page1/img5.png';
import img6 from '../assets/Page1/img6.png';
import img7 from '../assets/Page1/img7.png';
import img8 from '../assets/Page1/img8.png';
import img9 from '../assets/Page1/img9.png';
import img10 from '../assets/Page1/img10.png';

const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10];

const Carousel = () => {
  const [focusedIndex, setFocusedIndex] = useState(0);

  // auto-advance carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setFocusedIndex(prev => (prev + 1) % images.length);}, 5000);
    return () => clearInterval(interval);}, []);

  return (
    <div className="carousel-wrapper">
      <div
        className="carousel-inner"
        style={{
          transform: `translateX(-${focusedIndex * 200}px)` // move the container
        }}
      >
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Slide ${index}`}
            className={`carousel-img ${index === focusedIndex ? 'center' : 'side'}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;